import { com } from '@eidu/form'
import FieldData, { NewFieldData } from '../../domain/entity/FieldData'
import Field = com.eidu.sharedlib.entity.field.Field
import FieldId = com.eidu.sharedlib.entity.field.FieldId

export const prepareFieldsToCreate = (fields: readonly FieldData[]): Field[] =>
  fields.filter((field) => !field.existing).map((field) => (field as NewFieldData).field)

export const prepareFieldNameUpdates = (
  currentFields: readonly FieldData[],
  originalFields: readonly FieldData[]
): Field[] => {
  const fieldsWithNameUpdates: Field[] = []

  currentFields.forEach((currentField) => {
    if (currentField.existing) {
      const originalField = originalFields.find((field) => field.field.id?.equals(currentField.field.id))
      if (originalField && originalField.field.name !== currentField.field.name) {
        fieldsWithNameUpdates.push(currentField.field)
      }
    }
  })

  return fieldsWithNameUpdates
}

export const prepareFieldsToDelete = (
  currentFields: readonly FieldData[],
  originalFields: readonly FieldData[]
): FieldId[] => {
  const currentFieldIds = new Set(
    currentFields.map((field) => field.field.id?.toString()).filter((fieldId): fieldId is string => !!fieldId)
  )

  return originalFields
    .filter((field) => field.field.id && !currentFieldIds.has(field.field.id.toString()))
    .map((field) => field.field.id!)
}
